import { Download, X } from "lucide-react";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";
import { Button } from "@/components/ui/button";

/**
 * Shows a subtle banner at the top of the app shell when the browser
 * supports PWA installation and the user hasn't dismissed it yet.
 * Hidden automatically when already running as an installed PWA.
 */
export function InstallBanner() {
  const { isInstallable, isStandalone, triggerInstall, dismiss } =
    useInstallPrompt();

  if (isStandalone || !isInstallable) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-app-primary/10 border-b border-app-primary/20 text-sm shrink-0">
      <Download className="w-4 h-4 text-app-primary shrink-0" />
      <span className="flex-1 text-app-text">
        Install ChoreApp for quick access from your home screen
      </span>
      <Button
        size="sm"
        className="h-7 text-xs bg-app-primary hover:bg-app-primary/90 text-white"
        onClick={triggerInstall}
      >
        Install
      </Button>
      <button
        onClick={dismiss}
        className="text-app-text-muted hover:text-app-text transition-colors"
        aria-label="Dismiss install banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
